export default {
  // 实时变化Signature
  makeSignature(params, reqTime) {
    let paramsKeys = Object.keys(params).sort();
    let paramsStr = '';
    for (let paramsKey of paramsKeys) {
      paramsStr += `${paramsKey}=${params[paramsKey]}&`;
    }
    return $.md5(paramsStr + reqTime);
  },

  // 获取网站来源
  // getUrlParam(name) {
  //     let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  //     let r = window.location.search.substr(1).match(reg);
  //     if (r != null) return unescape(r[2]);
  //     return null;
  // },

  // getUrlParam(key) {
  //     var href = window.location.href;
  //     var url = href.split("?");
  //     if(url.length <= 1){
  //        return "";
  //     }
  //     var params = url[1].split("&");

  //     for(var i=0; i<params.length; i++){
  //        var param = params[i].split("=");
  //        if(key == param[0]){
  //           return param[1];
  //        }
  //     }
  //  },

  getUrlParam(name) {
    let reg = new RegExp('(^|/?|&)' + name + '=([^&]*)(&|$)');
    let r = window.location.href.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },

  // gTag
  gtag() {
    dataLayer.push(arguments);
  },


  goShare(code) {
    switch (code) {
      case 'naver':
        window.open(`https://game.naver.com/lounge/moe/home`, '_blank');
        gtag("event", "NaverLounge_page");

        break;
      // case 'ds':
      //   window.open(`https://game.naver.com/lounge/moe/home`, '_blank');
      //   break;
      case 'twi':
        window.open(`https://x.com/moerai_KR`, '_blank');
        break;
      case 'yt':
        window.open(`https://youtube.com/channel/UCsqzi2j4pMbd4zGddcEx-cA?si=H97AzZi6tRpfsBm6`, '_blank');
        gtag("event", "youtube_page");

        break;
      case 'gp':
        window.open(`https://cof.ujoygames.com/MnDS/homepageaos`, '_blank');
        gtag("event", "GP_click");

        break;
      case 'ios':
        window.open(`https://cof.ujoygames.com/MnDS/homepageios`, '_blank');
        gtag("event", "AS_click");

        break;
      case 'os':
        window.open(`https://cof.ujoygames.com/MnDS/homepageonestore`, '_blank');
        gtag("event", "OS_click");

        break;
    }
  },

  // 错误码

  // 错误码
  errCode(code) {
    switch (code) {
      case 10499:
        ERR_TEXT = '중복 조작'
        break;
      case 10500:
        ERR_TEXT = '불법 채널'
        break;
      case 10501:
        ERR_TEXT = '불법 서명'
        break;
      case 20000:
        ERR_TEXT = '서명 검증 실패'
        break;
      case 20001:
        ERR_TEXT = '플랫폼 사용자 데이터가 존재하지 않습니다'
        break;
      case 20002:
        ERR_TEXT = '공개 사용자 데이터가 존재하지 않습니다'
        break;
      case 20003:
        ERR_TEXT = '계정 비밀번호 오류'
        break;
      case 20004:
        ERR_TEXT = '방문 토큰이 만료되었습니다'
        break;
      case 20005:
        ERR_TEXT = '방문 토큰이 유효하지 않습니다'
        break;
      case 20006:
        ERR_TEXT = '사용자 생성 실패'
        break;
      case 20007:
        ERR_TEXT = '게스트 계정은 로그인이 제한되어 있습니다. 해당 계정은 공식 계정에 연동되어 있습니다'
        break;
      case 20008:
        ERR_TEXT = '이메일이 존재하지 않습니다'
        break;
      case 20009:
        ERR_TEXT = '인증코드 오류'
        break;
      case 20010:
        ERR_TEXT = '계정생성 실패, 24시간 후  다시 시도해 주세요.'
        break;
      case 20011:
        ERR_TEXT = '로그인 실패，24시간 후  다시 시도해 주세요.'
        break;
      case 20012:
        ERR_TEXT = '인증 실패，24시간 후  다시 시도해 주세요.'
        break;
      case 20013:
        ERR_TEXT = '요청 실패，24시간 후  다시 시도해 주세요.'
        break;
      case 20014:
        ERR_TEXT = '요청 시간 간격이 너무 짧습니다'
        break;
      case 20020:
        ERR_TEXT = '로그인 채널 계정 정보 오류'
        break;
      case 20021:
        ERR_TEXT = '로그인 채널 계정 유형 오류'
        break;
      case 20022:
        ERR_TEXT = '연동된 로그인 채널 계정은 수정할 수 없습니다'
        break;
      case 20023:
        ERR_TEXT = '해당 로그인 채널 계정은 다른 사람에 의해 연동되었습니다'
        break;
      case 20024:
        ERR_TEXT = '이메일 형식이 올바르지 않습니다'
        break;
      case 20025:
        ERR_TEXT = '비밀번호가 너무 짧습니다'
        break;
      case 20026:
        ERR_TEXT = '잘못된 로그인 채널 증명'
        break;
      case 20027:
        ERR_TEXT = '해당 이메일 주소가 이미 등록되었습니다'
        break;
      case 20028:
        ERR_TEXT = '계정은 이메일 주소와 비밀번호에 등록되어 있지 않습니다'
        break;
      case 20029:
        ERR_TEXT = '게스트 계정은 로그인이 제한되어 있습니다. 이 계정은 코드에 연결되어 있습니다.'
        break;
      case 20030:
        ERR_TEXT = '비밀번호에 잘못된 문자가 포함되어 있습니다'
        break;
      case 20031:
        ERR_TEXT = '서버 점검 중...'
        break;
      case 30000:
        ERR_TEXT = '주문이 존재하지 않습니다'
        break;
      case 30001:
        ERR_TEXT = '주문을 취소할 수 없습니다，상태: %s'
        break;
      case 30002:
        ERR_TEXT = '충전상품이 존재하지 않습니다'
        break;
      case 30003:
        ERR_TEXT = '주문을 생성 실패，msg: %s'
        break;
      case 30004:
        ERR_TEXT = '주문 반복 생성'
        break;
      case 30005:
        ERR_TEXT = '주문 확인에 실패. 주문을 다시 생성해 주세요'
        break;
      case 30006:
        ERR_TEXT = '상품 배송 실패，状态：%s'
        break;
      case 30007:
        ERR_TEXT = '게임 서버가 응답하지 않음'
        break;
      case 30008:
        ERR_TEXT = '결제 방식이 존재하지 않습니다'
        break;
      case 30009:
        ERR_TEXT = '결제 기관이 존재하지 않습니다'
        break;
      case 30010:
        ERR_TEXT = '잘못된 구매 데이터'
        break;
      case 30011:
        ERR_TEXT = '잘못된 결제 영수증'
        break;
      case 30012:
        ERR_TEXT = '결제 플랫폼에서 영수증을 확인하지 못했습니다'
        break;
      case 30013:
        ERR_TEXT = '결제 플랫폼이 토큰을 획득 실패'
        break;
      case 30014:
        ERR_TEXT = '결제 영수증 중 빌드명 오류.'
        break;
      case 30015:
        ERR_TEXT = '결제 영수증 사용되었습니다.'
        break;
      case 30016:
        ERR_TEXT = '결제 영수증 상태 오류'
        break;
      case 40000:
        ERR_TEXT = '주문 생성 실패'
        break;
      case 40001:
        ERR_TEXT = '주문 결제 실패'
        break;
      case 40002:
        ERR_TEXT = '주문 발송 실패'
        break;
      case 40100:
        ERR_TEXT = '쿠폰 수령 불가'
        break;
      case 40101:
        ERR_TEXT = '쿠폰 교환 불가'
        break;
      case 40102:
        ERR_TEXT = '쿠폰 사용 불가'
        break;
    }
  }


}



// WEBPACK FOOTER //
// ./src/commonFunction/common.js